import React from 'react';
import { Link } from 'react-router-dom';


const CommingSoon = () => {

   
    return (
        <div id="wrapper">

            <div className="vertical-align-wrap">
                <div className="vertical-align-middle maintenance">

                <div className="text-center">
                    <div>
                        <h1>We&rsquo;ll be back soon!</h1>
                        <div>
                            <p>Sorry for the inconvenience<br/> but we&rsquo;re performing some maintenance at the moment.<br/> If you need to you can always
                             <a href="mailto:#">contact us</a>, otherwise we&rsquo;ll be back online shortly!</p>
                            <p>&mdash; The Team</p>
                        </div>
                    </div>
                    <div className="margin-top-30">
                        {/* <a href="javascript:history.go(-1)" className="btn btn-default"><i className="fa fa-arrow-left"></i> <span>Go Back</span></a> */}
                        <Link to="/" className="btn custom-btn-outline-info"><i className="fa fa-home"></i> <span>Home</span></Link>
                    </div>
                </div>
                </div>
            </div>
            
        </div>
    )
}

export default CommingSoon;